import { render, staticRenderFns } from "./RegionLogs.vue?vue&type=template&id=5155311d&"
import script from "./RegionLogs.vue?vue&type=script&lang=js&"
export * from "./RegionLogs.vue?vue&type=script&lang=js&"
import style0 from "./RegionLogs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports